"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeItemContent = void 0;
const react_1 = __importStar(require("react"));
const generic_1 = require("../../../generic");
exports.TreeItemContent = react_1.default.forwardRef(function CustomTreeContent(_a, ref) {
    var { className, status, isChanged, onExpand, children } = _a, rest = __rest(_a, ["className", "status", "isChanged", "onExpand", "children"]);
    const { expanded, selected } = status;
    const innerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (selected) {
            innerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [selected]);
    (0, react_1.useEffect)(() => {
        if (expanded) {
            onExpand();
        }
    }, [expanded, onExpand]);
    const handleSetRef = (node) => {
        innerRef.current = node;
        if (typeof ref === 'function') {
            ref(node);
        }
        else if (ref) {
            ref.current = node;
        }
    };
    return (react_1.default.createElement("div", Object.assign(Object.assign({}, rest), { className: className, ref: handleSetRef }), isChanged && react_1.default.createElement(generic_1.ChangeMark, { className: "tree-item-change-mark" }), children));
});
exports.default = exports.TreeItemContent;
